import React, { useState, useEffect } from 'react';
import dbService from '../../../services/dbService';
import { Link } from 'react-router-dom';
import { BellFill, BriefcaseFill, PersonXFill, ArrowUpRightCircleFill } from 'react-bootstrap-icons';
import PageContainer from '../../layout/PageContainer'; // <-- IMPORT

const Dashboard = () => {
    const [stats, setStats] = useState({ newAlerts: 0, openCases: 0, unassignedCases: 0, escalatedCases: 0, conversionRate: 0 });
    const [recentAlerts, setRecentAlerts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            const allAlerts = await dbService.getAll('alerts');
            const newAlerts = allAlerts.filter(a => a.status === 'New');
            
            const allCases = await dbService.getAll('cases');
            const openCases = allCases.filter(c => c.status !== 'Closed');
            const unassignedCases = openCases.filter(c => c.assignedTo === 'Unassigned' || c.assignedTo.includes('Banking'));
            const escalatedCases = allCases.filter(c => c.status === 'Escalated');
            
            const totalAlertsReviewed = allAlerts.filter(a => a.status !== 'New').length;
            const casesCreatedFromAlerts = allAlerts.filter(a => a.status === 'Case Created').length;
            const conversionRate = totalAlertsReviewed > 0 ? ((casesCreatedFromAlerts / totalAlertsReviewed) * 100).toFixed(1) : 0;

            setStats({
                newAlerts: newAlerts.length,
                openCases: openCases.length,
                unassignedCases: unassignedCases.length,
                escalatedCases: escalatedCases.length,
                conversionRate: conversionRate,
            });
            setRecentAlerts(newAlerts.sort((a,b) => b.riskScore - a.riskScore).slice(0, 5)); // Show 5 highest risk
            setIsLoading(false);
        };
        fetchData();
    }, []);

    return (
         <PageContainer title="Analyst Dashboard">
            <div className="row">
                <div className="col-xl-3 col-md-6 mb-4">
                    <Link to="/alert-queue" className="card border-left-danger shadow h-100 py-2 text-decoration-none">
                        <div className="card-body">
                        <div className="row no-gutters align-items-center">
                                <div className="col mr-2">
                                    <div className="text-xs font-weight-bold text-danger text-uppercase mb-1">New Alerts</div>
                                    <div className="h5 mb-0 font-weight-bold text-gray-800">{stats.newAlerts}</div>
                                </div>
                                <div className="col-auto"><BellFill size={32} className="text-gray-300" /></div>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-xl-3 col-md-6 mb-4">
                    <Link to="/case-management" className="card border-left-warning shadow h-100 py-2 text-decoration-none">
                        <div className="card-body">
                            <div className="row no-gutters align-items-center">
                                <div className="col mr-2">
                                    <div className="text-xs font-weight-bold text-warning text-uppercase mb-1">Unassigned Cases</div>
                                    <div className="h5 mb-0 font-weight-bold text-gray-800">{stats.unassignedCases}</div>
                                </div>
                                <div className="col-auto"><PersonXFill size={32} className="text-gray-300" /></div>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-xl-3 col-md-6 mb-4">
                    <div className="card border-left-info shadow h-100 py-2">
                        <div className="card-body">
                        <div className="row no-gutters align-items-center">
                                <div className="col mr-2">
                                    <div className="text-xs font-weight-bold text-info text-uppercase mb-1">Cases Escalated</div>
                                    <div className="h5 mb-0 font-weight-bold text-gray-800">{stats.escalatedCases}</div>
                                </div>
                                <div className="col-auto"><ArrowUpRightCircleFill size={32} className="text-gray-300" /></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-md-6 mb-4">
                    <div className="card border-left-success shadow h-100 py-2">
                        <div className="card-body">
                        <div className="row no-gutters align-items-center">
                                <div className="col mr-2">
                                    <div className="text-xs font-weight-bold text-success text-uppercase mb-1">Alert-to-Case Conversion</div>
                                    <div className="h5 mb-0 font-weight-bold text-gray-800">{stats.conversionRate}%</div>
                                </div>
                                <div className="col-auto"><BriefcaseFill size={32} className="text-gray-300" /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="card shadow mb-4">
                <div className="card-header py-3">
                    <h6 className="m-0 font-weight-bold text-primary">Highest Priority Alerts</h6>
                </div>
                <div className="card-body">
                    {isLoading ? <p>Loading...</p> : recentAlerts.length > 0 ? (
                        <ul className="list-group list-group-flush">
                            {recentAlerts.map(alert => (
                                <li key={alert.id} className="list-group-item d-flex justify-content-between align-items-center">
                                    <div>
                                        <strong>{alert.customerName}</strong>
                                        <br/>
                                        <small className="text-muted">Triggered Rule: {alert.ruleName}</small>
                                    </div>
                                    <div>
                                        <span className="badge bg-danger me-3">Score: {alert.riskScore}</span>
                                        <Link to="/alert-queue" className="btn btn-sm btn-outline-danger">Review Alert</Link>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    ) : <p className="text-center text-muted">No new alerts to display.</p>}
                </div>
            </div>
         </PageContainer>
    );
};

export default Dashboard;